export const InfoSlide = [
  // {
  //   image:
  //     '/banner.png',
  //   href: '',
  //   name: 'Hệ thống thông gió Khách sạn Gold Valley Dalat',
  //   desc: 'Sản xuất và lắp đặt hệ thống ABC gia đoạn CDE tại nhà máy Yakult Bình Dương',
  //   date: '2024',
  // },
  {
    image:
      'https://images.unsplash.com/photo-1628615315488-14ec7d02daaf?q=80&w=2532&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    href: '',
    name: 'Hệ thống thông gió nhà máy Yakult Bình Dương',
    desc: 'Sản xuất và lắp đặt hệ thống ABC gia đoạn CDE tại nhà máy Yakult Bình Dương',
    date: '2024',
  },
  {
    image:
      'https://images.unsplash.com/photo-1593462430565-94f606c65e71?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    href: '',
    name: 'Hệ thống thông gió TTTM SC VivoCity',
    desc: 'Nằm dọc theo đại lộ Nguyễn Văn Linh, Quận 7, SC VivoCity gồm năm tầng cung cấp các sản phẩm thời trang mới nhất, đại siêu thị, hệ thống rạp phim, cũng như các cửa hàng ăn uống, giải trí, giáo dục, phong cách sống.',
    date: '2015',
  },
  {
    image:
      'https://images.unsplash.com/photo-1623428454609-8ed6a4628b66?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    href: '',
    name: 'Hệ thống thông gió Đại học Công Nghệ Thông Tin TPHCM',
    desc: 'ĐH CNTT sở hữu cơ sở vật chất gồm khu học tập, nghiên cứu và làm việc được đầu tư xây dựng khang trang, hiện đại với tổng diện tích trên 14 hecta trong khuôn viên khu đô thị ĐHQG-HCM.',
    date: '2010',
  },
];
